import "whatwg-fetch"
import { GET_TOKEN_URL } from "../../v1/actions/paymentMethods"
import i18n from "./i18n"
import { trackEvent } from "./segmentAnalytics"
import { EN, FR, FR_LANG, USD } from "../../v1/constants/tires"

export const saveCC = ({ user, authentication_token, instance, storeUser, getPaymentMethods }) => {
  return new Promise((resolve, reject) =>
    instance.requestPaymentMethod(async (requestPaymentMethodErr, payload) => {
      if (requestPaymentMethodErr && requestPaymentMethodErr.message) {
        window.alert(
          `${i18n.t("setupBraintree:errorTitle")} ${
            requestPaymentMethodErr.message === "No payment method is available."
              ? i18n.t("setupBraintree:pleaseInputPaymentInfoText")
              : requestPaymentMethodErr.message
          }`
        )
        resolve(false)
      } else {
        let response = await fetch("/api/v4/customers/" + user.id, {
          method: "PUT",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: authentication_token
          },
          body: JSON.stringify({
            payment_method_nonce: payload.nonce
          })
        })

        if (response.status === 200) {
          storeUser({ ...user, ...{ has_cc_info_saved: true } })

          getPaymentMethods(user)
          resolve(true)
          trackEvent("payment-method-added", {
            paymentMode: payload.type == "CreditCard" ? "Credit Card" : "Paypal",
            source: window.location.hash
          })
        } else {
          let json = await response.json()
          window.alert(`${i18n.t("setupBraintree:errorTitle")} ${json.errors}`)
          resolve(false)
        }
      }
    })
  )
}

export const setupBraintree = async ({ authentication_token, div }) => {
  let response = await fetch(GET_TOKEN_URL, {
    method: "GET",
    headers: { Authorization: authentication_token }
  })
  let clientToken = (await response.json()).client_token
  return new Promise((res, rej) => {
    import("braintree-web-drop-in").then((dropin) => {
      dropin.create(
        {
          authorization: clientToken,
          container: div,
          locale: i18n.language.match("fr") ? "fr_FR" : "en",
          card: {
            cardholderName: {
              required: true
            }
          },
          paypal: {
            flow: "vault"
          }
        },
        (createErr, instance) => {
          console.log(createErr)
          res(instance)
        }
      )
    })
  })
}

export const setupPaypalBraintree = async ({ authentication_token, div, amount }) => {
  let response = await fetch(GET_TOKEN_URL, {
    method: "GET",
    headers: { Authorization: authentication_token }
  })
  let clientToken = (await response.json()).client_token
  return new Promise((res, rej) => {
    import("braintree-web-drop-in").then((dropin) => {
      dropin.create(
        {
          authorization: clientToken,
          container: div,
          locale: i18n.language.match(FR) ? FR_LANG : EN,
          paypal: {
            flow: "checkout",
            amount: amount,
            currency: USD,
            buttonStyle: {
              tagline: false,
              height: 52
            }
          },
          card: false
        },
        (createErr, instance) => {
          console.log(createErr)
          res(instance)
        }
      )
    })
  })
}
